import { render } from "./test-item-skeleton.vue?vue&type=template&id=574d4787&scoped=true"
import script from "./test-item-skeleton.vue?vue&type=script&lang=js"
export * from "./test-item-skeleton.vue?vue&type=script&lang=js"

import "./test-item-skeleton.vue?vue&type=style&index=0&id=574d4787&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574d4787"]])

export default __exports__